import React, { useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";

export default function PaymentHistory() {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);
    const companyId = localStorage.getItem('company_id');

    useEffect(() => {
        const fetchPayments = async () => {
            try {
                
                const res = await axiosInstance.get(`/payment/history/${companyId}`);
                setPayments(res.data.data);
                console.log(res.data.data);
            } catch (err) {
                console.error("Error fetching payment history:", err);
            } finally {
                setLoading(false);
            }
        };
        if (companyId) fetchPayments();
    }, [companyId]);

    if (loading) {
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <h1 className="m-0">Payment History</h1>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <p className="text-muted mt-2">Loading payment records...</p>
                    </div>
                </section>
            </div>
        );
    }

    if (payments.length === 0) {
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <h1 className="m-0">Payment History</h1>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="card card-warning">
                            <div className="card-header">
                                <h3 className="card-title">No Payments Found</h3>
                            </div>
                            <div className="card-body text-center">
                                <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
                                <p>There are no payment records for this company.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Payment History</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">Dashboard</li>
                                <li className="breadcrumb-item active">Payment History</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary card-outline">
                                <div className="card-header">
                                    <h3 className="card-title">
                                        <i className="fas fa-credit-card mr-2"></i>
                                        Payment Records
                                    </h3>
                                </div>
                                <div className="card-body table-responsive p-0">
                                    <table className="table table-hover text-nowrap table-bordered table-striped">
                                        <thead className="thead-light">
                                            <tr className="text-center">
                                                <th>Payment ID</th>
                                                <th>Plan ID</th>
                                                <th>Amount (₹)</th>
                                                <th>Status</th>
                                                <th>Payment Date</th>
                                                <th>Expiry Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {payments.map((p) => (
                                                <tr key={p.id} className="text-center">
                                                    <td>{p.razorpay_payment_id}</td>
                                                    <td>{p.plan.name}</td>
                                                    <td>₹{p.amount}</td>
                                                    <td>
                                                        <span className="badge badge-success">{p.status.toUpperCase()}</span>
                                                    </td>
                                                    <td>{new Date(p.payment_date).toLocaleString()}</td>
                                                    <td>{new Date(p.expiry_date).toLocaleDateString('en-GB')}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="card-footer text-right">
                                    <strong>Total Payments:</strong> {payments.length}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
